/** Appends an async vendor script once per URL. A blocked load (ad blocker,
 *  network) costs nothing: the stub keeps queueing and the game never waits. */
export function loadScript(src: string): void {
  if (Array.from(document.scripts).some((script) => script.src === src)) return;
  const script = document.createElement('script');
  script.async = true;
  script.src = src;
  document.head.append(script);
}
